import Vue from 'vue';

Vue.prototype.$eventHub = new Vue();

/**
 * Initializes vue and all its components
 */
export default function InitVueApp() {
	Vue.component('audio-player', require('../components/AudioPlayer.vue').default);
	Vue.component('autocomplete-address-field', require('../components/AutocompleteAddressField.vue').default);
	Vue.component('milestones', require('../components/Milestones.vue').default);
	Vue.component('bandwidth-comparison', require('../components/BandwidthComparison.vue').default);
	Vue.component('tab-collapse', require('../components/TabCollapse.vue').default);
	Vue.component('tab-collapse-item', require('../components/TabCollapseItem.vue').default);
	Vue.component('card-collapse', require('../components/CardCollapse.vue').default);
	Vue.component('availability-checker', require('../components/AvailabilityChecker.vue').default);
	Vue.component('vertical-slider', require('../components/VerticalSlider.vue').default);
	Vue.component('vertical-slider-item', require('../components/VerticalSliderItem.vue').default);
	Vue.component('faq', require('../components/FAQ.vue').default);
	Vue.component('oaid-checker', require('../components/OaidChecker.vue').default);

	const vueApp = new Vue({
		el: '.page-container',
		mounted() {
			let anchorID = window.location.hash.substring(1);
			let anchorElement = anchorID.length > 0 ? document.querySelector(`#${anchorID}`) : null;

			setTimeout(() => {
				if (anchorID && anchorElement)
					anchorElement.scrollIntoView();
			}, 200);
		}
	});
}